import { takeLatest, put, call } from "redux-saga/effects";
import * as loginActions from "./actions";
import { LOGIN_REQUEST, EMAILOTP_REQUEST } from "./types";
import api from "../../../network/apis/api";

function* loginFunction(action) {
  try {
    const response = yield call(api.post, "/user-service/api/super-admin/login", action.payload);
    if (response.status === 200) {
      yield action.cb(response.data);
      yield put(loginActions.loginSuccess(response.data));
    } else if (response.status === 400) {
    } else if (response.status === 401) {
    } else {
      yield put(loginActions.loginError("error"));
    }
    if (action.cb) yield action.cb(response.data);
  } catch (e) {
    yield put(loginActions.loginError(e));
  }
}
function* EmailOTPFunction(action) {
  try {
    const response = yield call(api.post, "/user-service/api/email/send-otp", action.payload);
    if (response.status === 200) {
      yield action.cb(response.data);
      yield put(loginActions.EmailOTPSuccess(response.data));
    } else {
      yield put(loginActions.EmailOTPError("error"));
    }
  } catch (e) {
    yield put(loginActions.EmailOTPError(e));
  }
}

export default function* authSaga() {
  yield takeLatest(LOGIN_REQUEST, loginFunction); // similarly add required functions
  yield takeLatest(EMAILOTP_REQUEST, EmailOTPFunction)
}
